import clsx from "clsx";
import React from "react";
import { ActionsMenu } from "../../common/components/ActionsMenu";
import { ConditionalWrapper } from "../../common/components/ConditionalWrapper";
import { useDropdown } from "../../common/components/dropdown/useDropdown";
import { MENU_FAVORITES_OPTIONS, MODAL_ADD_TO_FAVORITES } from "../../common/components/modals/constants";
import useModal from "../../common/components/modals/useModal";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import useSearchState from "../useSearchState";
import { numberWithSpaces } from "../utils";
import useFavorites from "./useFavorites";

export function FavoriteDropdown() {
	const { rows, results, resultsAreLoaded } = useSearchState([""]);
	const {
		selectedCodes,
		onInputChange,
		handleModalContent,
		handleAddAllResults,
		handleAddSelectedResults,
	} = useFavorites();
	const { dropdownRef, dropdownIsOpened, onDropdownToggle } = useDropdown();
	const { isMobile } = useAccessWindowSize();
	const { onOpenModal } = useModal();

	const handleDropdownToggleClick = (e) => {
		e.target.blur();
		onDropdownToggle();
		onOpenModal(MENU_FAVORITES_OPTIONS);
	};

	const handleDropdownItemClick = () => {
		onDropdownToggle();
		onOpenModal(MODAL_ADD_TO_FAVORITES);
	};

	const handleAddSelected = () => {
		handleModalContent(selectedCodes.size === 1 ? "entity" : "entities");
		handleAddSelectedResults();
		handleDropdownItemClick();
	};

	const handleAddAllOnPage = () => {
		const codesOnPage = rows
			.map((row) => row.getIn(["airline", "code"]))
			.toArray();
		const codes = selectedCodes.clear().concat(codesOnPage);
		onInputChange(codes);
		handleModalContent("page");
		handleAddSelectedResults();
		handleDropdownItemClick();
	};

	const handleAddAll = () => {
		handleModalContent("all");
		handleAddAllResults();
		handleDropdownItemClick();
	};

	if (!resultsAreLoaded) {
		return null;
	}

	return (
		<div ref={dropdownRef} className="dropdown dropdown--secondary">
			<button
				type="button"
				className="dropdown-toggle btn--has-icon btn--favorite"
				aria-expanded={dropdownIsOpened}
				onClick={handleDropdownToggleClick}
			>
				<span>Favourite</span>
			</button>

			<ConditionalWrapper
				condition={isMobile}
				wrapper={(children) => (
					<ActionsMenu
						id={MENU_FAVORITES_OPTIONS}
						showBackButton
						title="Favourite"
					>
						{children}
					</ActionsMenu>
				)}
			>
				<div
					className={clsx("dropdown-menu", {
						"dropdown-menu--opened": dropdownIsOpened,
					})}
				>
					<ul className="dropdown-menu-items">
						<li>
							<button
								type="button"
								className="dropdown-item"
								id="all-selected"
								onClick={handleAddSelected}
								disabled={selectedCodes.size === 0}
							>
								Only selected ({selectedCodes.size})
							</button>
						</li>
						<li>
							<button
								type="button"
								className="dropdown-item"
								id="all-on-page"
								onClick={handleAddAllOnPage}
							>
								All on page ({rows.size})
							</button>
						</li>
						<li>
							<button
								type="button"
								className="dropdown-item"
								id="all-results"
								onClick={handleAddAll}
							>
								All ({numberWithSpaces(results)})
							</button>
						</li>
					</ul>
				</div>
			</ConditionalWrapper>
		</div>
	);
}
